(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Muted background clips on LPs: make sure they play when on screen (some browsers skip autoplay).
    function init() {
      var vids = document.querySelectorAll('.lp-media video, .lp-hiw__media video');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          v.muted = true;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    }
    // Headline fit: every sentence on one line. Shrinks the h1 only when a sentence is wider than the copy column.
    function fit() {
      document.querySelectorAll('h1[data-lp-fit]').forEach(function (h) {
        var lines = h.querySelectorAll('.lp-h1__line');
        if (lines.length < 2) return;
        h.style.fontSize = '';
        h.style.lineHeight = '';
        h.classList.remove('lp-h1--wrap');
        h.classList.add('lp-h1--fit');
        var box = h.parentElement, bs = getComputedStyle(box);
        var avail = box.clientWidth - parseFloat(bs.paddingLeft) - parseFloat(bs.paddingRight);
        var widest = 0;
        lines.forEach(function (l) { widest = Math.max(widest, l.getBoundingClientRect().width); });
        if (!avail || !widest || widest <= avail) return;
        var hs = getComputedStyle(h), fs = parseFloat(hs.fontSize), lh = parseFloat(hs.lineHeight);
        var min = window.innerWidth < 768 ? 28 : 36;
        var want = fs * (avail / widest) * 0.98;
        if (want < min) { h.classList.add('lp-h1--wrap'); return; }
        var size = Math.floor(want);
        h.style.fontSize = size + 'px';
        if (lh) h.style.lineHeight = (lh * size / fs).toFixed(1) + 'px';
      });
    }
    var t;
    function onResize() { clearTimeout(t); t = setTimeout(fit, 120); }
    function start() {
      init();
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.addEventListener('resize', onResize);
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-products"]) return;
  try {
    
  (function () {
    if (customElements.get('lp-gift-card')) return;
    // The amount picker sets ?variant= on the link, so the gift card page opens on that amount
    // (where the buyer can add the recipient's email, a message and a send date).
    class LpGiftCard extends HTMLElement {
      connectedCallback() {
        var link = this.querySelector('[data-lp-gc-link]');
        if (!link) return;
        this.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'radio') link.href = link.dataset.baseUrl + '?variant=' + e.target.value;
        });
      }
    }
    customElements.define('lp-gift-card', LpGiftCard);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-signature"]) return;
  try {
    
  if (!customElements.get('lp-carousel')) {
    customElements.define(
      'lp-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-lp-track]');
          this.slides = Array.from(this.querySelectorAll('[data-lp-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-lp-dot]'));
          this.prev = this.querySelector('[data-lp-prev]');
          this.next = this.querySelector('[data-lp-next]');
          if (!this.track || !this.slides.length) return;
          this.dots.forEach((dot) =>
            dot.addEventListener('click', () => this.goTo(Number(dot.dataset.lpDot)))
          );
          this.prev?.addEventListener('click', () => this.step(-1));
          this.next?.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.update();
        }
        stepSize() {
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return this.slides[0].getBoundingClientRect().width + gap;
        }
        index() {
          return Math.round(this.track.scrollLeft / this.stepSize());
        }
        goTo(i) {
          this.track.scrollTo({ left: i * this.stepSize(), behavior: 'smooth' });
        }
        step(dir) {
          this.goTo(Math.max(0, Math.min(this.slides.length - 1, this.index() + dir)));
        }
        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          const atEnd = this.track.scrollLeft >= max;
          const i = atEnd ? this.slides.length - 1 : this.index();
          this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = atEnd;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sticky-cta"]) return;
  try {
    
  if (!customElements.get('lp-sticky-cta')) {
    customElements.define(
      'lp-sticky-cta',
      class extends HTMLElement {
        connectedCallback() {
          const hero = document.querySelector('[data-lp-hero]');
          const products = document.getElementById('lp-products');
          if (!hero || !('IntersectionObserver' in window)) return;
          let heroVisible = true;
          let productsVisible = false;
          const render = () => this.classList.toggle('is-visible', !heroVisible && !productsVisible);
          new IntersectionObserver(([e]) => { heroVisible = e.isIntersecting; render(); }).observe(hero);
          if (products) {
            new IntersectionObserver(([e]) => { productsVisible = e.isIntersecting; render(); }).observe(products);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
